import React from 'react';

const M27EmbeddedPage = ({ pageUrl }) => <iframe
  src={pageUrl}
  title="Embedded Page"
  className="fixed inset-0 w-full h-full"
  allow="fullscreen"
/>;

export default M27EmbeddedPage;